<script setup>
import { VueDraggableNext as Draggable } from 'vue-draggable-next';

import { ref, defineProps, defineEmits } from 'vue';

const props = defineProps({
	questions: {
		type: Array,

		required: true,
	},
});

const emit = defineEmits(['close']);

const questions = ref(props.questions);

const activeIndex = ref(null);

const moveQuestion = (from, to) => {
	const [item] = questions.value.splice(from, 1);

	questions.value.splice(to, 0, item);
};

const upQuestion = (index) => {
	if (index > 0) {
		moveQuestion(index, index - 1);

		activeIndex.value = index - 1;
	}
};

const downQuestion = (index) => {
	if (index < questions.value.length - 1) {
		moveQuestion(index, index + 1);

		activeIndex.value = index + 1;
	}
};

const onDragStart = (evt) => {
	activeIndex.value = evt.oldIndex;
};

const onDragEnd = (evt) => {
	activeIndex.value = evt.newIndex;
};

const selectItem = (index) => {
	activeIndex.value = index;
};
</script>

<template>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 w-screen md:w-1/2">
		<div
			class="h-full w-full flex flex-col bg-white shadow-xl overflow-y-auto"
		>
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-center justify-between gap-1">
					<div class="flex items-center">
						<img
							src="@/assets/images/icons/order.png"
							alt="order"
							class="w-6 h-6"
						/>

						<div class="text-2xl font-bold text-neutral-700 ml-2">
							Sắp xếp lại các phần
						</div>
					</div>

					<div class="cursor-pointer" @click="emit('close')">
						<svg
							class="h-6 w-6"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							aria-hidden="true"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</div>
				</div>
			</div>

			<div
				class="sideover-content relative flex-1 px-4 sm:px-6 py-6"
				style="scroll-behavior: smooth"
				id="slide-over"
			>
				<Draggable
					:list="questions"
					handle=".drag-handle"
					ghost-class="order-item-ghost"
					chosen-class="order-item--active"
					drag-class="order-item--dragging"
					@start="onDragStart"
					@end="onDragEnd"
				>
					<div
						v-for="(question, index) in questions"
						:key="question.id ?? index"
						class="order-item"
						:class="{ 'order-item--active': activeIndex === index }"
						@click="selectItem(index)"
					>
						<div class="flex items-center justify-between gap-10">
							<div class="flex items-center gap-4 min-w-0 flex-1">
								<img
									src="@/assets/images/icons/drag.png"
									alt="order"
									class="drag-handle w-6 h-6 shrink-0 cursor-move"
								/>

								<div
									class="text-neutral-600 text-sm font-semibold shrink-0"
								>
									{{
										question.question_type === 'section'
											? 'Tiêu đề'
											: 'Câu hỏi'
									}}
								</div>

								<div
									class="text-neutral-700 min-w-0 break-words whitespace-pre-wrap text-sm"
								>
									{{
										question.title || `Câu hỏi ${index + 1}`
									}}
								</div>
							</div>

							<div
								class="flex shrink-0 items-center gap-4"
								@click.stop
							>
								<img
									src="@/assets/images/icons/arrow-down.png"
									alt="arrow-down"
									class="cursor-pointer"
									:class="{
										'opacity-30 pointer-events-none':
											index === questions.length - 1,
									}"
									@click="downQuestion(index)"
								/>

								<img
									src="@/assets/images/icons/arrow-up.png"
									alt="arrow-up"
									class="cursor-pointer"
									:class="{
										'opacity-30 pointer-events-none':
											index === 0,
									}"
									@click="upQuestion(index)"
								/>
							</div>
						</div>
					</div>
				</Draggable>
			</div>

			<div class="px-6 py-4 border-t border-yellow-50">
				<div class="flex justify-end">
					<div>
						<button
							type="button"
							class="button-p text-center w-32"
							@click="emit('close')"
						>
							Xác nhận
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.order-item {
	position: relative;
	padding: 16px;
	border: 1px solid #e1e7ef;
	background: #fff;
	cursor: pointer;
	transition: border-left-color 0.15s ease, background-color 0.15s ease;
}

.order-item--active,
:deep(.order-item--active) {
	border-left-width: 6px;
	border-left-color: #e5a42b;
	background: #fff;
	z-index: 1;
	padding: 32px 16px 32px 10px;
}

.drag-handle {
	transition: transform 0.2s ease-in-out;
}

.drag-handle:active {
	transform: scale(1.1);
}
</style>

